import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import SEO from '../components/seo';
import '../styles/app.scss';
import LineFull from '../images/linefull.jpg';

function getElementOffset(el) {
    let top = 0;
    let left = 0;
    let element = el;

    // Loop through the DOM tree
    // and add it's parent's offset to get page offset
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top,
        left,
    };
}

const campsFaqList = [
    {
        faq_question: 'What ages can attend School’s Out Camp?',
        faq_answer:
            'School’s Out Camp is designed for children ages 4–12 who are fully potty trained.',
    },
    {
        faq_question: 'What are the camp hours?',
        faq_answer:
            'Full-day camp runs from 9:00 AM–3:00 PM. Half-day options are 9:00 AM–12:00 PM and 12:00–3:00 PM.',
    },
    {
        faq_question: 'How much does camp cost?',
        faq_answer:
            'Full-day camp is $120 per child. Half-day camp is $75 per child. Eligible siblings receive a 10% discount.',
    },
    {
        faq_question: 'Is advance registration required?',
        faq_answer:
            'Yes. Advance registration and completed camp paperwork are required. Space is limited, and walk-in participation is not guaranteed.',
    },
    {
        faq_question: 'Is camp offered every time schools are closed?',
        faq_answer:
            'No. Camp is offered on select school-closure dates based on facility and staffing availability.',
    },
    {
        faq_question: 'What should my child bring?',
        faq_answer:
            'Families should send lunch, snacks, a labeled water bottle, grippy socks, and any other items listed in the registration instructions.',
    },
    {
        faq_question: 'Is this a sensory-friendly camp?',
        faq_answer:
            'Camp is held inside our inclusive sensory gym. Activities are designed to provide opportunities for movement, play, creativity, and social interaction.',
    },
];

const camps = ({ data }) => {
    const { wordpressPage: post } = data;
    console.log(post);
    const test_title = post.yoast_title;
    const new_test_title = test_title.replace('&#039;', "'");
    const inlineCss = {
        maxWidth: '600px',
        marginTop: '50px',
    };

    function handleAccordion(e) {
        const AccId = e.target.getAttribute('data-target');
        const buttonTriggers = document.querySelectorAll('.accordion-trigger');
        const accordionList = document.querySelectorAll('.collapse');

        // remove all arias from buttons
        buttonTriggers.forEach(button => {
            button.removeAttribute('aria-expanded');
            button.classList.add('collapsed');
        });
        e.target.classList.remove('collapsed');

        // hide all except clicked one
        accordionList.forEach(accordion => {
            const accContentId = accordion.getAttribute('id');
            if (accContentId !== AccId) {
                accordion.classList.remove('show');
            }
        });

        const elementToShow = document.getElementById(AccId);
        const elementOffset = getElementOffset(e.target);

        // show hide element
        if (elementToShow.classList.contains('show')) {
            elementToShow.classList.remove('show');
            e.target.classList.add('collapsed');
        } else {
            elementToShow.classList.add('show');
            // scroll element into view
            window.scrollTo({
                top: elementOffset.top - 250,
                left: 0,
                behavior: 'smooth',
            });
        }
    }

    return (
        <>
            <SEO
                title={new_test_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: post.content,
                        }}
                    />
                </div>
            </section>            
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt">
                    <h2 className="yellowtxt">Pricing Information</h2>
                 {/*   <p><strong>$160 per 6-Week Session</strong> (1 Class Per Week)</p> */}
                    <div className="schedule-table-wrap">
                        <table className="schedule-table">
                            <thead>
                                <tr>
                                    <th>Full Day — <strong>Best Value</strong></th>
                                    <th>Half Day</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Full Day — Best Value">
                                        9:00 AM–3:00 PM<br /><br />
                                        <strong>$120</strong> per child; siblings discounted to <strong>$108</strong>
                                    </td>
                                    <td data-label="Half Day">
                                        9:00 AM–12:00 PM or 12:00–3:00 PM<br /><br />
                                        <strong>$75</strong> per child; siblings discounted to <strong>$67.50</strong>
                                    </td>
                                </tr>
                         {/*       <tr>
                                    <td data-label="Wednesday Evenings">
                                        <strong>Preschool/Kinder</strong> (Ages 3–6)<br /><br />
                                        ⏱ 5:45 PM – 6:30 PM
                                    </td>
                                    <td data-label="Saturday Mornings">
                                        <strong>Preschool/Kinder</strong> (Ages 3–6)<br /><br />
                                        ⏱ 9:50 AM – 10:30 AM
                                    </td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <p style={{ marginTop: '20px' }}><strong>Advance registration is required. Space is limited, and availability may vary by date.</strong></p>
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white">
                <div className="container smallestwdt" style={{ maxWidth: '800px' }}>
                    <h3 className="yellowtxt">Who Can Attend?</h3>
                    <p style={{ marginTop: '30px' }}><strong>School’s Out Camp is available for children:</strong></p> 
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Ages 4–12</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Who are fully potty trained</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Who can participate safely within the camp environment</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Who have all required registration forms and waivers completed</li>
                    </ul>
                   {/* <h3 className="yellowtxt" style={{ marginTop: '30px' }}>Membership & Cancellation Terms</h3> */}
                    <p style={{ marginTop: '30px' }}>If a child requires continuous one-to-one assistance, the family should contact us before registering to discuss available participation options.</p>
                </div>
            </section>
            <section className="page-section smallestwdt respitesec padding-less-under">
                <div className="container">
                    <h2 className="bluetxt" style={{ marginBottom: '60px', textAlign: 'center' }}>What Campers Can Expect</h2>
                    <div className="openplft">
                        <img style={{ marginBottom: 0 }}
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/09/Schools-Out-Flyer.webp"
                            alt="Schools Out Flyer"
                        />
                    </div>
                    <div className="openprgt withmarbtm">
                        <ul className="startxt starlistspacing">
                            <li className="bluetxt">Supervised sensory-gym play</li>
                            <li className="bluetxt">Gross-motor movement</li>
                            <li className="bluetxt">Games and group activities</li>
                            <li className="bluetxt">Arts, crafts, or creative projects</li>
                            <li className="bluetxt">Music and movement</li>
                            <li className="bluetxt">Opportunities for social interaction</li>
                            <li className="bluetxt">Structured and independent play</li>
                            <li className="bluetxt">Snack and lunch breaks</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="page-section smallestwdt respitesec padding-less-under" style={{ paddingTop: 0 }}>
                <div className="container">
                    <h3 className="bluetxt" style={{ marginBottom: '40px', textAlign: 'center' }}>FAQs</h3>

                    <div className="accordion" id="accordioncampfaq">
                        {campsFaqList.map((faq, i) => {
                            let classCollapse = 'collapse';
                            let buttonCollapse =
                                'btn btn-link collapsed accordion-trigger';
                            if (i === 0) {
                                classCollapse = 'collapse show';
                                buttonCollapse =
                                    'btn btn-link accordion-trigger';
                            }
                            return (
                                <div className="card" key={i}>
                                    <div
                                        className="card-header"
                                        id={`campheading_${i}`}
                                    >
                                        <h2 className="mb-0">
                                            <button
                                                className={buttonCollapse}
                                                type="button"
                                                data-toggle="collapse"
                                                data-target={`campcollapse_${i}`}
                                                aria-expanded="true"
                                                aria-controls={`campcollapse_${i}`}
                                                onClick={handleAccordion}
                                                dangerouslySetInnerHTML={{
                                                    __html: faq.faq_question,
                                                }}
                                            />
                                        </h2>
                                    </div>

                                    <div
                                        id={`campcollapse_${i}`}
                                        className={classCollapse}
                                        aria-labelledby={`campheading_${i}`}
                                        data-parent="#accordioncampfaq"
                                    >
                                        <div
                                            className="card-body"
                                            dangerouslySetInnerHTML={{
                                                __html: faq.faq_answer,
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>            
            <section className="whywelist page-section">
                <img className="linemar nomartopimg" src={LineFull} alt="linefull" />
                <div className="container smallestwdt">
                    <h3 className="bluetxt">Winter Break Camp Is Coming!</h3>
                    <p style={{ marginTop: '30px' }}>
                        We’re preparing special Winter Break Camp options to help parents plan ahead for the extended school break.<br/>
                        Dates, hours, pricing, and registration details will be posted soon.<br/>
                        Stay tuned—space will be limited!
                    </p>
                </div>
            </section>
            <section
                className="whywelist page-section bg-primary text-white"
                id="contformsec"
            >
                <div className="container smallestwdt">
                    <h3 className="yellowtxt">Secure Your Camper's Spot Today</h3>
                    <p>Have other questions? Call us directly at <strong>732-339-8002</strong> or email <strong>info@werockthespectrumpiscataway.com</strong>.</p>
                    <div className="container flexwrap contactform_wrap">
                        <iframe
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/camps/"
                            title="contactform"
                        />
                    </div>
                </div>
            </section>
            
            <Footer />
        </>
    );
};

export default camps;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content            
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
